export default __webpack_public_path__ + "static/media/CNo.47-2.644923fd.jpg";